import { render, staticRenderFns } from "./BracketsRoundsList.vue?vue&type=template&id=65e52dc0&scoped=true"
import script from "./BracketsRoundsList.vue?vue&type=script&lang=js"
export * from "./BracketsRoundsList.vue?vue&type=script&lang=js"
import style0 from "./BracketsRoundsList.vue?vue&type=style&index=0&id=65e52dc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e52dc0",
  null
  
)

export default component.exports